import { render } from "./ActivityTaskPreSvgIcon.vue?vue&type=template&id=1135476e"
import script from "./ActivityTaskPreSvgIcon.vue?vue&type=script&lang=js"
export * from "./ActivityTaskPreSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__